import styles from './styles/common-overview.module.css';

export default function CommonOverview({ title, data, error, loading }) {
    const formatNumber = (number) => {
        return new Intl.NumberFormat().format(number); // 숫자에 구분자(쉼표) 추가
    };

    if (loading || !loading && error) { // 로딩 중인 경우 or 로딩이 끝난 후 에러가 발생한 경우
        return <div className={`${styles.wrapper} ${styles.loading}`} />;
    }

    if (!loading && (data === 0 || data)) {
        return (
            <div className={styles.wrapper} datatype={title}>
                <p>{title}</p>
                <p>
                    {title === '현재 접속자'
                        ? `${formatNumber(data)}명`
                        : `${formatNumber(data)}건`
                    }
                </p>
            </div>
        );
    }
}
